'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BinaryInterpreter2 = require('./BinaryInterpreter');

var _BinaryInterpreter3 = _interopRequireDefault(_BinaryInterpreter2);

var _ISOUtil = require('./ISOUtil');

var _ISOUtil2 = _interopRequireDefault(_ISOUtil);

var _Arrays = require('jsdk/util/Arrays');

var _Arrays2 = _interopRequireDefault(_Arrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Sean sean.snow@live.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2015/12/25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var LiteralBinaryInterpreter = function (_BinaryInterpreter) {
    _inherits(LiteralBinaryInterpreter, _BinaryInterpreter);

    function LiteralBinaryInterpreter() {
        _classCallCheck(this, LiteralBinaryInterpreter);

        return _possibleConstructorReturn(this, (LiteralBinaryInterpreter.__proto__ || Object.getPrototypeOf(LiteralBinaryInterpreter)).apply(this, arguments));
    }

    _createClass(LiteralBinaryInterpreter, [{
        key: 'interpret',
        value: function interpret(data, b, offset) {
            _Arrays2.default.arraycopy(data, 0, b, offset, data.length);
        }
    }, {
        key: 'uninterpret',
        value: function uninterpret(rawData, offset, length) {
            var ret = new Array(length);
            _Arrays2.default.arraycopy(rawData, offset, ret, 0, length);
            return ret;
        }
    }, {
        key: 'getPackedLength',
        value: function getPackedLength(nBytes) {
            return nBytes;
        }
    }]);

    return LiteralBinaryInterpreter;
}(_BinaryInterpreter3.default);

exports.default = new LiteralBinaryInterpreter();


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/LiteralBinaryInterpreter.js
// module id = 14
// module chunks = 0